const styles = theme => ({
  subdomainContainer: {
    maxWidth: 800,
    whiteSpace: "normal",
    textOverflow: "unset",
    wordBreak: "break-word",
    color: theme.palette.primary.default
  },
  inputReusableFormControl: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4)
  },
  labelTextColor: {
    color: theme.palette.primary.default
  },

  subdomain: {
    color: theme.palette.primary.light
  },
  subdomainExplanation: {
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.default
  },
  subDomainText: {
    color: theme.palette.primary.default
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/pages/OrganizationSignUp/steps/Step1Organization/styles.js